import { lazy, Suspense } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { BasePage } from 'hydra/pages/BasePage';
import { Loader } from 'common/components/Loader';

const DashboardContent = lazy(() =>
    import('dashboard/components/DashboardContent').then((m) => ({
        default: m.DashboardContent,
    }))
);

export const DashboardPage = () => {
    const [translate] = useTranslation();

    return (
        <BasePage contentContainerMaxWidth="lg">
            <Box sx={{ mt: 4, mb: 4 }}>
                <Typography variant="h1">
                    {translate('dashboard.pageTitle')}
                </Typography>
            </Box>

            <Suspense fallback={<Loader />}>
                <DashboardContent />
            </Suspense>
        </BasePage>
    );
};
